import { render, staticRenderFns } from "./UPackage.vue?vue&type=template&id=1eebaa6e&scoped=true&"
import script from "./UPackage.vue?vue&type=script&lang=js&"
export * from "./UPackage.vue?vue&type=script&lang=js&"
import style0 from "./UPackage.vue?vue&type=style&index=0&id=1eebaa6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebaa6e",
  null
  
)

export default component.exports